import { render } from "./VsChip.vue?vue&type=template&id=0c6164d1"
import script from "./VsChip.vue?vue&type=script&lang=js"
export * from "./VsChip.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__